var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hot_svg__prefix__clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.492,
    width: 28.415,
    height: 14.208,
    rx: 3,
    transform: "rotate(-21.67 0 10.492)",
    fill: "url(#hot_svg__prefix__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.655 17.97l1.073-.427-.954-2.401 2.747-1.091.954 2.4 1.076-.427-2.245-5.652-1.077.428.95 2.392-2.746 1.091-.95-2.392-1.074.427 2.246 5.651zm10.238-7.34c-.726-1.827-2.323-2.44-3.877-1.822-1.557.619-2.296 2.159-1.57 3.986.725 1.824 2.32 2.44 3.877 1.82 1.554-.617 2.296-2.158 1.57-3.985zm-1.08.428c.511 1.286.111 2.254-.855 2.638-.964.383-1.922-.045-2.433-1.331-.51-1.286-.108-2.255.856-2.638.966-.384 1.921.045 2.432 1.331zm.797-2.595l1.833-.728 1.904 4.794 1.065-.423-1.904-4.794 1.832-.728-.341-.858-4.73 1.879.342.858z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot_svg__prefix__paint0_linear",
    x1: 14.208,
    y1: 10.492,
    x2: 14.208,
    y2: 24.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0080"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hot_svg__prefix__clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.492,
    width: 28.415,
    height: 14.208,
    rx: 3,
    transform: "rotate(-21.67 0 10.492)",
    fill: "#fff"
  })))));
}
export default SvgHot;